import styled from 'styled-components';

export const ContactMe = styled.div`
  display: grid;
  justify-items: center;
  background: ${props => props.theme.borderGray};
  padding: 20px;
  box-shadow: inset 0px 100px 29px -85px rgba(0,0,0,0.3);
`;

export const DataContactMe = styled.div`
  display: grid;
  align-items: center;
  gap: 25px;
  position: relative;

  a {
    color: white;
    font-size: 20px;
  }

  i { font-size: 30px }
  .email { left: 220px }

  span {
    font-size: 14px;
    font-weight: 100;
    position: absolute;
    top: -15px;
  }

  .number-email {
    display: grid;
    grid-template-columns: repeat(2, 200px);
    justify-items: center;
    gap: 20px;
  }

  .icons-socials {
    display: grid;
    grid-template-columns: repeat(5, 30px);
    justify-content: space-around;
  }

  @media (max-width: 425px) {
    .number-email {
      grid-template-columns: auto;
    }

    .number-email a {
      margin: 10px 0;
    }
    
    .number-email .number {
      top: -5px;
      left: 20px;
    }

    .number-email .email {
      top: 60px;
      left: 20px;
    }

    .icons-socials {
      gap: 25px;
    }
  }
`;

export const Made = styled.div`
  font-weight: 300;
  display: grid;
  justify-items: center;
  align-items: center;
  grid-template-columns: 170px 190px;
  gap: calc(100% - 360px);
  background: ${props => props.theme.darkGray};
  padding: 20px;

  div {
    display: grid;
    justify-items: center;
    align-items: center;
    grid-template-columns: 80px 25px 27px 25px;
    gap: 2px;
  }

  p { margin: 0 }

  i { font-size: 20px }

  @media (max-width: 425px) {
    grid-template-columns: auto;

    div {
      display: none;
    }
  }
`;
